export default {
  stats: {
    orders: 'Orders',
    sales: 'Revenue',
  },
};
